import { useQuery } from '@tanstack/react-query';
import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

const fetchPersonnelToVerifyFields = (sessionId, mappedId) => {
  const url = `/personnelComparisonTool/${ sessionId }/personnelToVerify/fields?mappedId=${ mappedId }`;
  return fetch(url).then(decodeJson)
    .catch(({ body }) => {
      throw new ApiError(
        body ? `Error: ${ body }` : 'Could not load Personnel to verify data'
      );
    });
}

function processPersonResponse (response) {
  return response?.fields?.map((field) => ({
    id: field.name,
    fieldName: field.name,
    prettyName: field.prettyName,
    difference: field.status === 'DIFF',
    securityControlValue: field.secconValue,
    documentValue: field.systemValue
  }));
}
const usePersonnelToVerifyFields = (sessionId, mappedId) => useQuery({
  queryKey: ['personnelToVerifyFields', sessionId, mappedId],
  queryFn: () => fetchPersonnelToVerifyFields(sessionId, mappedId),
  enabled: !!sessionId && !!mappedId,
  select: processPersonResponse,
  staleTime: 0,
  refetchOnWindowFocus: false,
  keepPreviousData: true
})
export default usePersonnelToVerifyFields;
